














































import { Component, Prop, Emit, Mixins } from 'vue-property-decorator';
import SFormElement from './SFormElement.vue';
import SElementValidationErrors from './SElementValidationErrors.vue';

@Component({
  components: {
    SElementValidationErrors,
  },
})
export default class SCheckbox extends Mixins(SFormElement) {
  @Prop(String) private label?: string;
  @Prop(Boolean) private disabled?: boolean;

  private focused = false;

  private get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  @Emit('input')
  private handleInput(event: {target: HTMLInputElement}) {
    return event.target.checked;
  }
}
